const DAY_MS = 24 * 60 * 60 * 1000;

export const DEFAULT_TIME_ZONE = "US/Pacific";

const formatterFor = (timeZone) =>
  new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

const partsAt = (ms, timeZone) =>
  Object.fromEntries(
    formatterFor(timeZone)
      .formatToParts(new Date(ms))
      .filter(({ type }) => type !== "literal")
      .map(({ type, value }) => [type, Number(value)]),
  );

const offsetAt = (ms, timeZone) => {
  const p = partsAt(ms, timeZone);
  const wallClockAsUtc = Date.UTC(
    p.year,
    p.month - 1,
    p.day,
    p.hour,
    p.minute,
    p.second,
  );

  return wallClockAsUtc - Math.floor(ms / 1000) * 1000;
};

const utcMidnight = (date) => {
  const [year, month, day] = date.split("-").map(Number);

  return Date.UTC(year, month - 1, day);
};

const isoDate = (ms) => new Date(ms).toISOString().slice(0, 10);

export const addDays = (date, n) => isoDate(utcMidnight(date) + n * DAY_MS);

export const daysBetween = (from, to) =>
  Math.round((utcMidnight(to) - utcMidnight(from)) / DAY_MS);

/* The second pass corrects for a changeover between the naive guess and the answer. */
export const startOfLocalDay = (date, timeZone) => {
  const guess = utcMidnight(date);
  const first = guess - offsetAt(guess, timeZone);

  return new Date(guess - offsetAt(first, timeZone)).toISOString();
};

export const localDate = (instant, timeZone) => {
  const { year, month, day } = partsAt(new Date(instant).getTime(), timeZone);

  return isoDate(Date.UTC(year, month - 1, day));
};

const HAS_OFFSET = /(Z|[+-]\d\d:\d\d)$/;

/* MySQL DATETIME strings carry no zone, and the connection writes them in UTC. */
export const instantMs = (value) =>
  value instanceof Date
    ? value.getTime()
    : typeof value === "string"
    ? Date.parse(HAS_OFFSET.test(value) ? value : `${value.replace(" ", "T")}Z`)
    : null;

export const toSqlDateTime = (iso) => iso.slice(0, 19).replace("T", " ");
